import React, { useEffect, useRef } from 'react';
import QRCode from 'qrcode';

interface QRCodeGeneratorProps {
  /** Texto a codificar (uso histórico: el id de un registro). */
  id?: string;
  /** Texto a codificar; si viene, manda sobre `id` (p. ej. una URL completa). */
  value?: string;
  size?: number;
}

export interface QrSvgOptions {
  /** Ancho/alto del SVG en px (el QR es cuadrado). */
  size?: number;
  /** Módulos de margen alrededor del código. */
  margin?: number;
  dark?: string;
  light?: string;
}

/** El QR como SVG (texto): para descargarlo o incrustarlo sin perder nitidez. */
export function toSvg(text: string, { size = 512, margin = 2, dark = '#000000', light = '#FFFFFF' }: QrSvgOptions = {}): Promise<string> {
  return QRCode.toString(text, { type: 'svg', width: size, margin, color: { dark, light } });
}

/** El QR como PNG (data URL) para descargarlo o pegarlo en un documento. */
export function toPngDataUrl(text: string, { size = 512, margin = 2, dark = '#000000', light = '#FFFFFF' }: QrSvgOptions = {}): Promise<string> {
  return QRCode.toDataURL(text, { width: size, margin, color: { dark, light } });
}

const QRGenerator: React.FC<QRCodeGeneratorProps> = ({
  id,
  value,
  size = 200
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const text = value ?? id ?? '';

  useEffect(() => {
    if (text && canvasRef.current) {
      QRCode.toCanvas(canvasRef.current, text, {
        width: size,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        }
      }, (error: Error | null | undefined) => {
        if (error) console.error(error);
      });
    }
  }, [text, size]);

  return (
    <div className='rounded-[15px]'>
      <canvas ref={canvasRef} />
    </div>
  );
};

export default QRGenerator;
